import React from 'react';
import { FieldType } from 'types/FieldTypes';
import FormModal from 'components/modals/FormModal';

// The form to add or edit a ticket category
const TicketCategoryForm: React.FC<{ viewKey?: string }> = ({ viewKey }) => {

    const apiObject = 'ticket_category'

    // Plug in the fields and their properties
    const fields: FieldType[] = [
        {
            name: 'name',
            label: 'ticket.category.name_label',
            type: 'text',
            placeholder: 'ticket.category.name_placeholder',
        },
    ];

    return (
        <FormModal
            viewKey={viewKey}
            apiObject={apiObject}
            fields={fields}
        />
    );
};

export default TicketCategoryForm;
